<template>
  <ModalCore
    v-if="model"
    v-bind="$attrs"
    v-model="model"
    @update:model-value="(val) => emit('update:modelValue', val)"
  >
    <slot></slot>
  </ModalCore>
</template>

<script setup>
import ModalCore from './ModalCore.vue';
import { ref, watch } from 'vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});
const model = ref(props.modelValue);
watch(
  () => props.modelValue,
  (newVal) => {
    model.value = newVal;
  }
);
</script>

<style scoped></style>
